import GlobalMixin from '@/app/shared/mixins/global';
import BaseToolMixin from '@/app/shared/mixins/BaseToolMixin';
import MapPermissionsMixin from './MapPermissionsMixin';
import { POSITION } from '../ol/Control';
import { isArray } from '@config/utils';
import { CLASS_HIDDEN } from 'ol/css';

let map = {};

export default {
    mixins: [
        GlobalMixin,
        BaseToolMixin,
        MapPermissionsMixin,
    ],
    props: {
        moduleCode: {
            type: String,
            require: true,
            default: null
        },
        panelID: {
            type: String,
            default: null,
        },
        // title: {
        //     type: String,
        //     default: ''
        // },
        // acl: {
        //     type: Object,
        //     default: () => ({})
        // },
        // url: {
        //     type: Object,
        //     default: () => ({})
        // },
        showBtnMap: {
            type: Boolean,
            default: true
        },
        showLabelBtnMap: {
            type: Boolean,
            default: false
        },
        // labelBtnMap: {
        //     type: String,
        //     default: null
        // },
        idxBtnMap: {
            type: Number,
            default: 1
        },
        posBtnMap: {
            type: String,
            default: POSITION.BOTTOM_RIGHT_HORIZONTAL
        },
        subPosBtnMap: {
            type: String,
            default: null
        },
        collapsible: {
            type: Boolean,
            default: false
        },
        collapsed: {
            type: Boolean,
            default: false
        },
        showButtonOnActionMap: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            loaded: false,
            mapInitialized: false,
            mapIdentifier: null,
            ctrl: null,
            ctrlId: null,
            collapsibleClassName: "ol-collapsible",
            ignoreInitialState: false,
        }
    },
    computed: {
        applicationCode() {
            return this.$store.getters.applicationCode;
        },
        actionMap() {
            return this.moduleCode ? this.$store.getters[`${this.moduleCode}/getActionMap`] : null;
        },
        orderClassName() {
            return `order-${this.idxBtnMap} ${this.className} ${this.collapsibleClassNameButton}`;
        },
        lblBtn(){
            return this.showLabelBtnMap ? (this.tool && this.tool.label ? this.$t(this.tool.label) : this.title) : null;
        },
        isActive(){
            return this.isPanelActive;
        },
        showButtonOnMap(){
            return this.showBtnMap && (!this.isActionMap || (this.isActionMap && this.showButtonOnActionMap));
        },
        isActionMap(){
            return !!this.actionMap;
        },
        renderBtnMap(){
            return this.isActive && this.showButtonOnMap;
        },
        collapsibleClassNameButton() {
            return this.collapsible ? "ol-collapsible" : "";
        },
        isFeedbackOptionsActive(){
            return this.$store.getters[`feedbackOptionsActive`] ?? false;
        },
    },
    created() {
        if(!this.mapInitialized) {
            this.$eventBus.listen(this.moduleCode, 'map.loaded', this.onMapLoaded);
            this.$eventBus.listen(this.moduleCode, 'map.destroyed', this.onMapDestroyed);
        }
    },
    beforeDestroy() {
        // this.onMapDestroyed();
        this.$eventBus.remove(this.moduleCode, 'map.loaded', this.onMapLoaded);
        this.$eventBus.remove(this.moduleCode, 'map.destroyed', this.onMapDestroyed);
    },
    methods: {
        onMapLoaded: function(data) {
            if(!this.mapInitialized){
                this.mapIdentifier = data.id;
                map[this.mapIdentifier] = data.map;
                this.setButtonMap(this.renderBtnMap);
                this.setButtonInitialState();
                this.mapInitialized = true;
            }
        },
        onMapDestroyed: function(data) {
            let mapIdentifier = data?.id;
            if(this.mapIdentifier && mapIdentifier && this.mapIdentifier != mapIdentifier) return;

            this.resetControl();

            if(this.mapIdentifier && this.mapIdentifier in map){
                map[this.mapIdentifier] = null;
                delete map[this.mapIdentifier];
            }

            this.mapIdentifier = null;
            this.mapInitialized = false;
        },
        resetControl: function(){
            if(this.ctrl){
                let element = this.ctrl?.element;
                if(element) {
                    if(element.parentNode) {
                        element.parentNode.removeChild(element);
                    }
                    element.remove();
                    delete this.ctrl.element;
                }
                this.ctrl.setMap(null);
                this.ctrl.setTarget(null);
                this.ctrl.disposeInternal();
            }
            this.ctrl = null;
            this.ctrlId = null;
        },
        getMap: function(){
            return this.mapIdentifier ? map[this.mapIdentifier] : null;
        },
        setButtonMap: function(flag){
            const _map = this.getMap();
            if(!_map) return false;

            let mapControl = this.getMapControl();
            if(mapControl) {
                let element = mapControl.element || mapControl.target;
                if(element &&  element instanceof HTMLElement) {
                    const contains = element.classList.contains(CLASS_HIDDEN);
                    if (!contains && !flag) {
                        element.classList.add(CLASS_HIDDEN);
                    } else if (contains && flag) {
                        element.classList.remove(CLASS_HIDDEN);
                    }
                }
            }else{
                if(flag){
                    if(!this.ctrl){
                        if(this.showButtonOnMap){
                            let ctrl = this.addButtonMap(_map);
                            if(ctrl) {
                                // [TODO]
                                if(isArray(ctrl) && ctrl.length > 0) {
                                    ctrl = ctrl[0];
                                }
                                this.ctrlId = ctrl.ol_uid || ctrl.id;
                                this.ctrl = ctrl;
                            }
                        }
                    }else if (this.ctrl && this.ctrl.element){
                        let elem = this.ctrl.element;
                        if (elem.style) {
                            elem.style.display = "";
                        }
                    }
                }else{
                    if(this.ctrl && this.ctrl.element){
                        let elem = this.ctrl.element;
                        if (elem.style) {
                            elem.style.display = "none";
                        }
                    }
                }
            }
        },
        setButtonInitialState: function(){
            if(this.ctrl){
                let initialCollapsed = this.initialCollapsedExpandCollapse;
                if(!this.ignoreInitialState){
                    let el = $(this.ctrl.element);
                    if(this.collapsible && initialCollapsed && el.is(":visible")){
                        el.hide();
                    }
                }
            }
        },
        getMapControl: function() {
            const _map = this.getMap();
            if(_map){
                let id = this.ctrlId;
                return id ? [..._map.getControls().getArray()].find(control => control.ol_uid == id) : null;
            }
            return null;
        },
        addButtonMap: function(_map){
            if(!_map)
                return false;

            //[TODO] specific in each control
        },
    },
    watch: {
        renderBtnMap: {
            deep: true,
            immediate: false,
            handler(value, oldValue){
                this.setButtonMap(value);
            },
        },
        // actionMap: {
        //     deep: false,
        //     immediate: false,
        //     handler(value, oldValue){
        //         console.log('actionMap', value)
        //     },
        // },
    },
};